/* tslint:disable */
var TrackingEventDesktopDeviceInformation = /** @class */ (function () {
    function TrackingEventDesktopDeviceInformation(args) {
        this.EVENT_ID = 86;
        this.MAPPING_VERSION = 1;
        this.data = args;
        this.data.eventId = this.EVENT_ID;
        this.data.event_mapping_version = this.MAPPING_VERSION;
    }
    return TrackingEventDesktopDeviceInformation;
}());
export { TrackingEventDesktopDeviceInformation };
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/TrackingEventDesktopDeviceInformation.ts
// module id = 1695
// module chunks = 3